import { useState } from 'react';
import { isAvailableBrowser } from './constants';

/** Establece si el modal de navegador incompatible debe abrirse */
export function useBrowserModal() {
  const [isOpen, setModalDataVisibility] = useState(true);

  const sessionStorageKey = 'browserModalDisplayed';
  const alreadyDisplayed = sessionStorage.getItem(sessionStorageKey) === '1';

  const closeModal = () => {
    setModalDataVisibility(false);
    sessionStorage.setItem(sessionStorageKey, '1');
  };

  return {
    showModal: isOpen && !isAvailableBrowser && !alreadyDisplayed,
    closeModal,
  };
}
